angular.module('impactx.toast', []);